import { postJson } from "Shared/server";
import { currentUrl } from "Shared/url";
import { updateAppShellData } from "../../AppShell/action-creators";
import cookieHandler from "../../../Helpers/cookieHandler";
import { replaceState } from "Shared/history";
export const UPDATE_USERSETTINGS = "UPDATE_USERSETTINGS";
export function updateUserSettings(partialSettings, shouldUpdateAppShell = false) {
    return (dispatch, getState) => {
        const settings = Object.assign(Object.assign({}, getState().currentUser.userSettings), partialSettings);
        dispatch({
            type: UPDATE_USERSETTINGS,
            payload: settings,
        });
        cookieHandler.setCookie(settings.userSettingsCookieName, JSON.stringify(settings), 365);
        const url = currentUrl().path;
        return postJson("/UserSettings/Update", { settings, url })
            .then((result) => {
            if (partialSettings.selectedLanguageCode) {
                replaceState(result || url);
            }
            if (shouldUpdateAppShell) {
                dispatch(updateAppShellData());
            }
        })
            .catch((e) => {
            console.error(e);
        });
    };
}
